/**
 * Order and identity of the install steps; text lives in the `app` catalogue
 * under `extensionGate.guide.install.steps.<id>` — see ai/docs/i18n.md.
 */
export const EXTENSION_GUIDE_INSTALL_STEP_IDS = [
  "openStore",
  "addToBrowser",
  "verify",
] as const;
